import { render, staticRenderFns } from "./FileConvert.vue?vue&type=template&id=a020a33c&scoped=true"
import script from "./FileConvert.vue?vue&type=script&lang=js"
export * from "./FileConvert.vue?vue&type=script&lang=js"
import style0 from "./FileConvert.vue?vue&type=style&index=0&id=a020a33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a020a33c",
  null
  
)

export default component.exports